import React from 'react'
import { observer } from 'mobx-react'
import { i18nTranslate, enableHeaderMFE, isFeatureEnabled } from 'src/utils'
import { MetaDecorator } from 'src/views/components'
import { MicroFrontendLoader } from 'src/views/components/MicroFrontends/MicroFrontendLoader'
import { customerContainer, storeContainer } from 'src/models'
import { pageNames } from 'src/routes/pathParams'
@observer
class Returns extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    const pathname = this.props.location?.pathname
    if (customerContainer.isRegisterUser && pathname === pageNames?.return) {
      this.props.history?.push(pageNames.myaccountorders)
    }
  }
  render() {
    const returnsTitle = i18nTranslate('return.title', 'Nu Skin | Returns')
    const remoteConfig = {
      appName: 'returns',
    }
    const activeStoreData = {
      defaultCurrency:
        storeContainer?.activeStoreResponse?.defaultCurrency || '',
      defaultLocale: storeContainer?.activeStoreResponse?.defaultLocale || '',
    }
    const enableNarrowSymbolCurrencyFormat = isFeatureEnabled(
      'enableNarrowSymbolCurrencyFormat'
    )
    const enableDecimalRoundingInPrice = isFeatureEnabled(
      'enableDecimalRoundingInPrice'
    )
    const excludeSpaceInPrice = isFeatureEnabled('excludeSpaceInPrice')
    const params = {
      isRegisterUser: customerContainer.isRegisterUser,
      currentUrl: this.props?.location?.pathname,
      isLoadFromMfe: true,
      activeStoreResponse: activeStoreData || {},
      // Cross-MFE contract: returns MFE reads params.headerMfeEnabled in Initializer.tsx
      // to hide its own header when storefront Header MFE is active. Keep key in sync.
      headerMfeEnabled: enableHeaderMFE(),
      enableNarrowSymbolCurrencyFormat,
      enableDecimalRoundingInPrice,
      excludeSpaceInPrice,
    }
    return (
      <>
        <MetaDecorator
          title={returnsTitle}
          imageUrl=""
          imageAlt=""
          description={returnsTitle}
          location={this.props}
        />
        <MicroFrontendLoader remoteConfig={remoteConfig} params={params} />
      </>
    )
  }
}
export default Returns
export { Returns }
